'use strict';
define([
    'angular',
    'modules/keywordlistmanager/landing/landing.controller'
], function (angular, KeywordListManagerLandingCtrl) {
    var app = angular.module('app.keywordlistmanager.landing', []);
    app.controller('KeywordListManagerLandingCtrl', KeywordListManagerLandingCtrl);
    return app;
});
